




















































import { Component, Mixins } from "vue-property-decorator";

import Checkbox from "@/components/BaseCheckbox/BaseCheckbox.vue";
import BasePopup from "@/components/BasePopup/BasePopup.vue";
import BaseButton from "@/components/BaseButton/BaseButton.vue";
import LinearLoader from "@/components/LinearLoader/LinearLoader.vue";
import DataTable from "@/components/DataTable/DataTable.vue";

import EventBus from "@/utils/helpers/EventBus";
import SubjectsTable from "@/mixins/SubjectsTable.mixin";

import { Action } from "vuex-class";
import { ClassesTableItem } from "@/models/types/classes";
import { AxiosError, AxiosResponse } from "axios";

import amplitude from "amplitude-js";
import { eventCodeByName, EventsNames } from "@/analytics";

@Component({
  components: {
    Checkbox,
    BasePopup,
    BaseButton,
    LinearLoader,
    DataTable
  }
})
export default class StudentsTable extends Mixins<
  SubjectsTable<ClassesTableItem>
>(SubjectsTable) {
  @Action("classes/deleteClasses")
  private deleteClasses!: (
    classesIds: string[]
  ) => Promise<AxiosError | AxiosResponse>;

  private isDeletionPending = false;

  private get tableColumns() {
    const baseColumns = [
      {
        label: this.$t("tables.classes.teacher"),
        value: "teachers"
      },
      {
        label: this.$t("tables.classes.numberOfStudents"),
        value: "students"
      },
      {
        label: this.$t("tables.classes.lesson"),
        value: "assignedLesson"
      }
    ];

    const shouldShowSubGroupsColumn = this.data.some(item => item.subGroup);

    return shouldShowSubGroupsColumn
      ? [
          {
            label: this.$t("tables.classes.group"),
            value: "className"
          },
          {
            label: this.$t("tables.classes.subgroup"),
            value: "subGroup"
          },
          ...baseColumns
        ]
      : [
          {
            label: this.$t("tables.classes.group"),
            value: "className"
          },
          ...baseColumns
        ];
  }

  private onDelete() {
    if (!this.selectedDataItemsIds.length) {
      this.popupMessage = this.$t("components.warnings.selectGroups") as string;
    } else {
      const clasessNames = this.selectedDataItemsIds
        .map(id => {
          const { className } = this.data.find(item => item.groupId === id)!;

          return className;
        })
        .join(", ");

      this.popupMessage = this.$t(
        "components.warnings.deleteClasses"
      ) as string;
      this.action = "delete";
    }

    this.showPopup = true;
  }

  private onAdd() {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksAddClass)} ${
          EventsNames.UserClicksAddClass
        }`
      );
    this.$router.push("/classes/add");
  }

  private onEdit() {
    if (!this.selectedDataItemsIds.length) {
      this.popupMessage = this.$t("components.errors.selectGroups") as string;
      this.showPopup = true;
    } else if (this.selectedDataItemsIds.length > 1) {
      this.popupMessage = this.$t(
        "components.errors.editOneGroupAtOnce"
      ) as string;
      this.showPopup = true;
    } else {
      const classItem = this.data.find(
        item => item.groupId === this.selectedDataItemsIds[0]
      );

      this.$router.push(
        `/classes/${classItem?.groupId}/edit?name=${classItem?.className}`
      );
    }
  }

  private onPopupSubmit() {
    this.showPopup = false;

    switch (this.action) {
      case "delete":
        this.deleteClassesFromList();
        break;
      default:
        break;
    }
  }

  private deleteClassesFromList() {
    this.isDeletionPending = true;
    this.deleteClasses(this.selectedDataItemsIds)
      .then((r: AxiosResponse | AxiosError) => {
        const error = r instanceof Error;
        if (error) {
          const { response } = r as AxiosError;

          if (!response || response.status !== 403) {
            this.action = "";
            this.popupMessage = this.$t(
              "tables.classes.errors.failedDelete"
            ) as string;
            this.showPopup = true;
          }
        } else {
          this.selectedDataItemsIds = [];
        }
      })
      .finally(() => (this.isDeletionPending = false));
  }

  private mounted() {
    EventBus.$on("table-toolbar-delete", this.onDelete);
    EventBus.$on("table-toolbar-add", this.onAdd);
    EventBus.$on("table-toolbar-edit", this.onEdit);
  }

  private beforeDestroy() {
    EventBus.$off("table-toolbar-delete", this.onDelete);
    EventBus.$off("table-toolbar-add", this.onAdd);
    EventBus.$off("table-toolbar-edit", this.onEdit);
  }
}
